import React from "react";
import DOMPurify from "dompurify";

interface EvidenceBlockProps {
  header: string;
  children?: React.ReactNode;
  htmlContent?: string;
  textContent?: string;
  showDivider?: boolean;
}

const EvidenceBlock: React.FC<EvidenceBlockProps> = ({
  header,
  children,
  htmlContent,
  textContent,
  showDivider = true,
}) => {
  const sanitizeData = (data: string) => {
    return { __html: DOMPurify.sanitize(data) };
  };

  return (
    <div className="readEvidenceBlock">
      <div className="readEvidenceHeader">{header}</div>
      {children && children}
      {htmlContent && (
        <div
          className="readEvidenceText"
          dangerouslySetInnerHTML={sanitizeData(htmlContent)}
        />
      )}
      {textContent && <div className="readEvidenceText whitespace-pre-wrap">{textContent}</div>}
      {showDivider && <div className="h-[1px] w-full bg-grey-30 mt-4" />}
    </div>
  );
};

export default EvidenceBlock;
